function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAwsOpenedSvgrepoCom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "folder_type_aws_opened") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M27.4,5.5H18.2L16.1,9.7H4.3V26.5H29.5V5.5Zm0,18.7H6.6V11.8H27.4Zm0-14.5H19.2l1-2.1h7.1V9.7Z",
    style: {
      fill: "#d8a17c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "25.7 13.7 0.5 13.7 4.3 26.5 29.5 26.5 25.7 13.7",
    style: {
      fill: "#d8a17c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31,26.526v.955c0,1.73-1.909,3.52-4.236,3.52H14.236C11.879,31,10,29.241,10,27.481v-.955Z",
    style: {
      fill: "#9d5125"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.084,17.249a5.334,5.334,0,0,1,4.892,3.162,2.729,2.729,0,0,1,1.551-.477,2.687,2.687,0,0,1,2.714,2.625A4.267,4.267,0,0,1,31,26.407v.358c0,1.76-1.909,3.52-4.266,3.52h-12.5c-2.357,0-4.236-1.76-4.236-3.52v-.358a4.146,4.146,0,0,1,2.714-3.639v-.149A5.347,5.347,0,0,1,18.084,17.249Z",
    style: {
      fill: "#f58535"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.25,23.484l-1.4,4.892h.835l.328-1.193h1.432l.3,1.193h.835l-1.313-4.892Zm-.119,3.072.6-2.416h0l.567,2.416Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "21.097 27.332 21.067 27.332 20.411 23.484 19.575 23.484 18.949 27.302 18.919 27.302 18.263 23.484 17.487 23.484 18.442 28.406 19.337 28.406 19.963 24.707 19.993 24.707 20.619 28.406 21.544 28.406 22.528 23.484 21.723 23.484 21.097 27.332",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.064,25.721l-.537-.179c-.537-.209-.746-.447-.746-.865a.673.673,0,1,1,1.342,0v.089H25.9v-.119c0-.507-.119-1.283-1.4-1.283a1.351,1.351,0,0,0-1.521,1.4,1.3,1.3,0,0,0,1.044,1.342l.537.179a.821.821,0,0,1,.716.865.7.7,0,0,1-.746.716q-.805,0-.805-.895v-.119h-.776v.119a1.339,1.339,0,0,0,1.491,1.491c.984,0,1.641-.418,1.641-1.462A1.3,1.3,0,0,0,25.064,25.721Z",
    style: {
      fill: "#fff"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAwsOpenedSvgrepoCom);
export default __webpack_public_path__ + "static/media/aws-opened-svgrepo-com.5631f3d0487ef99e47499ee11c34a0a2.svg";
export { ForwardRef as ReactComponent };